import SampleSlideIn from "./SampleSlideIn/SampleSlideIn";
export interface ITestSlideInContent<T = any> {
    id: string;
    header: string;
    content: (props: T) => React.ReactNode;
}
export const SAMPLE_SLIDE_IN: ITestSlideInContent = {
    id: "SAMPLE",
    header: "Sample hello???",
    content: (props) => <SampleSlideIn {...props} />
}
// export const contentTypes: ISlideInContent[] = [
//     // ADD_USER,
//     CHANGE_PASSWORD,
//     // ADD_NOTE,
//     // LAUNCH_OPTIONS,
//     // ADD_NOTE,
// ];
